import { colorSystem } from '@/styles/theme'
import { HStack } from '@musinsa/mwms-ds'
import styled from 'styled-components'
import Text from '@/components/content/Text'
import { HTMLAttributes, PropsWithChildren } from 'react'
import { tokens } from '@musinsa/layer-tokens/desktop'

interface Props extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  label: string
  required?: boolean
}

export function FormField({ label, required, children, ...htmlDivProps }: Props) {
  const { className, ...restProps } = htmlDivProps

  return (
    <Wrap className={`form-field ${className || ''}`} {...restProps}>
      <LabelBox className="form-field-label-box">
        <HStack gap={2}>
          <Text>{label}</Text>
          {required && <Text color={tokens.layerDesktop['fg-accent']}>*</Text>}
        </HStack>
      </LabelBox>
      <InputBox className="form-field-input-box">{children}</InputBox>
    </Wrap>
  )
}

const Wrap = styled.div`
  width: 100%;
  display: flex;
  border: 1px solid ${colorSystem.border.divider};
`

const LabelBox = styled.div`
  width: 140px;
  padding: 8px 16px;
  background: ${colorSystem.bg.table.column};
  border-right: 1px solid ${colorSystem.border.divider};

  display: flex;
  align-items: center;
`

const InputBox = styled.div`
  flex: 1;
  padding: 8px;

  display: flex;
  flex-direction: column;
  justify-content: center;
`
